// src/services/api/userService.ts
import { apiClient } from './config';
import {
  IUserService,
  UserProfile,
  Order,
  OrganisationMenu,
  User,
  Shift,
} from '../interfaces';

export class UserService implements IUserService {
  private static instance: UserService;

  static getInstance(): UserService {
    if (!UserService.instance) {
      UserService.instance = new UserService();
    }
    return UserService.instance;
  }

  async getUserProfile(): Promise<UserProfile> {
    // This endpoint doesn't exist in your backend
    // Temporarily using local storage for mock implementation
    const profile = localStorage.getItem('userProfile');
    if (profile) {
      return JSON.parse(profile);
    }
    throw new Error('Profile endpoint not implemented in backend');
  }

  async updateUserProfile(profile: UserProfile): Promise<boolean> {
    // This endpoint doesn't exist in your backend
    // Temporarily using local storage for mock implementation
    localStorage.setItem('userProfile', JSON.stringify(profile));
    return true;
  }

  async getOrders(): Promise<Order[]> {
    const response = await apiClient.get<Order[]>('/api/user/orders');
    return response.data;
  }

  async addOrder(order: Order): Promise<boolean> {
    await apiClient.post('/api/user/orders', order);
    return true;
  }

  async updateOrder(order: Order): Promise<boolean> {
    await apiClient.put('/api/user/orders', order);
    return true;
  }

  async deleteOrder(id: number): Promise<boolean> {
    await apiClient.delete(`/api/user/orders/${id}`);
    return true;
  }

  async getOrganisationMenus(): Promise<OrganisationMenu[]> {
    const response = await apiClient.get<OrganisationMenu[]>(
      '/api/user/organisationmenus'
    );
    return response.data;
  }

  async getUsers(): Promise<User[]> {
    const response = await apiClient.get<User[]>('/api/user/users');
    return response.data;
  }

  // Note: Your backend has PUT /api/user/users endpoint but no corresponding method
  // Adding this method to match backend
  async updateUser(user: User): Promise<boolean> {
    await apiClient.put('/api/user/users', user);
    return true;
  }

  async getShiftsForMenu(menuId: number): Promise<Shift[]> {
    const response = await apiClient.get<Shift[]>(`/api/user/shifts/${menuId}`);
    return response.data;
  }
}
